<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="academicCourse.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="imageId">Image</label>
            <media-chooser
                id="imageId"
                v-model="academicCourse.imageId"
                type="image"
                id-only
                :error-border="hasError('imageId')"
            />
            <div class="invalid-feedback">
                {{ getError('imageId') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            academicCourse: {}
        };
    },

    watch: {
        academicCourse() {
            this.$emit('input', this.academicCourse);
        }
    },

    created() {
        this.academicCourse = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.academicCourse[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.academicCourse,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
